import loadable from '@loadable/component';

import './Search.css';

export default loadable(() => {
  return import('./Search.jsx');
});
